import { buildBindable } from '@monofe/di';
import { bindConfigLog, IConfigLogDestination, IConfigLogLevel, injectConfigLog, injectENV, TYPES, unbindConfigLog } from '@monofe/util';
const DEFAULTS = {
  LOGGINGLEVELSENABLED: [IConfigLogLevel.Milestone, IConfigLogLevel.Trace, IConfigLogLevel.Info, IConfigLogLevel.Warn, IConfigLogLevel.Error, IConfigLogLevel.Fatal],
  OUTPUTDESTINATIONS: [IConfigLogDestination.Console],
  OUTPUTCONFIGURATION: {
    [IConfigLogDestination.Console]: {},
    [IConfigLogDestination.Remote_Sentry]: {}
  }
};

function _build(container) {
  const env = injectENV(container);
  const config = {
    loggingLevelsEnabled: env.getValueWithDefault('REACT_APP_LOG_LEVELS', DEFAULTS.LOGGINGLEVELSENABLED),
    outputDestinations: env.getValueWithDefault('REACT_APP_LOG_DESTINATIONS', DEFAULTS.OUTPUTDESTINATIONS),
    outputConfiguration: env.getValueWithDefault('REACT_APP_LOG_SETTINGS', DEFAULTS.OUTPUTCONFIGURATION)
  };
  return Object.freeze(config);
}

export default buildBindable({
  id: TYPES.IConfigLog,
  dependencies: [TYPES.IEnv],
  bind: bindConfigLog,
  remove: unbindConfigLog,
  inject: injectConfigLog,
  build: container => Promise.resolve(_build(container))
});